export default "__VITE_ASSET__CdlHM3hp__"